const InfoEvent = {
  INFO_SCREEN_OPEN: 'info_screen_open'
};

export {InfoEvent};
